export const SERVICE_FAILURE = 'SERVICE_FAILURE';
export const LOAD_QUOTE_DATA = 'LOAD_QUOTE_DATA';
export const LOAD_QUOTE_USER_DATA_SUCCESS = 'LOAD_QUOTE_USER_DATA_SUCCESS';
export const CREATE_QUOTE = 'CREATE_QUOTE';
export const CREATE_QUOTE_SUCCESS = 'CREATE_QUOTE_SUCCESS';
export const CREATE_QUOTE_FAILURE = 'CREATE_QUOTE_FAILURE';
export const LOAD_QUOTE_FAILURE = 'LOAD_QUOTE_FAILURE';
export const LOAD_QUOTE_SUCCESS = 'LOAD_QUOTE_SUCCESS';
export const ADD_QUOTE_ADDRESS_FAILURE = 'ADD_QUOTE_ADDRESS_FAILURE';
export const ADD_QUOTE_ADDRESS = 'ADD_QUOTE_ADDRESS';
export const UPDATE_QUOTE_SHIP_ADDRESS = 'UPDATE_QUOTE_SHIP_ADDRESS';
export const UPDATE_QUOTE_BILL_ADDRESS = 'UPDATE_QUOTE_BILL_ADDRESS';
export const STORE_PREV_SHIP_ADDRESS = 'STORE_PREV_SHIP_ADDRESS';
export const STORE_PREV_BILL_ADDRESS = 'STORE_PREV_BILL_ADDRESS';
export const ADD_QUOTE_ADDRESS_SUCCESS = 'ADD_QUOTE_ADDRESS_SUCCESS';
export const ORDER_SIMULATE = 'ORDER_SIMULATE';
export const QUOTE_ANALYTICS_ON_LOAD = 'QUOTE_ANALYTICS_ON_LOAD';
